import {AnalyticsList} from '@src/pages/Analytics/AnalyticsList.tsx'


export default {
  list: <AnalyticsList />
}
